import { getGlobalCssUrl, getComponentCssUrl } from '../Global/loadDependency';

// Lazy template creation to avoid calling getCdnUrl at module load time
function createPropertyTemplate(includeGlobal = true) {
    const t = document.createElement('template');
    if (includeGlobal) {
        t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('Property--wc.css')}" rel="stylesheet" />
`;
    } else {
        t.innerHTML = `
<link href="${getComponentCssUrl('Property--wc.css')}" rel="stylesheet" />
`;
    }
    return t;
}

// Getter functions for templates
const getTemplatePropertyCompleteStyles = () => createPropertyTemplate(true);
const getTemplatePropertyMinimalStyles = () => createPropertyTemplate(false);

export { getTemplatePropertyCompleteStyles, getTemplatePropertyMinimalStyles }